<div
  #terpeneColumn
  [class.product-low-amount]="productStylingVm | isLowAmountTerpeneOrTAT: terpeneColumnType : !isOtherColumn | async"
  [ngStyle]="
    productStylingVm
      | lowAmountStyling: colVm : (productStylingVm | isLowAmountTerpeneOrTAT: terpeneColumnType : !isOtherColumn)
      | async
  "
  [style.margin-right]="menu | method: 'getSectionBorderMarginSize'"
  [style.visibility]="section?.collapseContent || rowVm.collapseContent ? 'collapse' : ''"
  [style.text-decoration]="productStylingVm | forcedColumnTextDecoration: colVm : locConfig | async"
  class="product-column-general product-terpene">
  <!-- ^ product-${terpene-kebab-cased} class gets added in the component ^ -->
  @if (isTopTerpeneColumn) {
    <app-handle-badge-mode
      [colVm]="colVm"
      [rowVm]="rowVm"
      [nonListColumnBadgeAsset]="this | method: 'getNonListColumnItem'">
      <ng-container *ngIf="useNgContent"><ng-content></ng-content></ng-container>
      <ng-container *ngIf="!useNgContent">
        {{ this | method: 'getNonListColumnItem' }}
      </ng-container>
    </app-handle-badge-mode>
  } @else if (isListTerpeneColumn) {
    <app-column-list-items
      [colVm]="colVm"
      [rowVm]="rowVm"
      [displayFormat]="displayFormat"
      [sectionColumnType]="colVm.columnType"
      [columnListLayoutModifierClass]="columnListLayoutModifierClass"
      [parentColumnElement]="terpeneColumn">
    </app-column-list-items>
  } @else if (isOtherColumn) {
    <ng-container *ngIf="useNgContent"><ng-content></ng-content></ng-container>
    <ng-container *ngIf="!useNgContent">{{
      rowVm | method: 'getTerpene' : terpeneColumnType : displayFormat
    }}</ng-container>
  }
</div>
